import { FC } from 'react';
import Link from 'next/link';
import BookCardRating from '../book-card-rating/BookCardRating';
import { IReviewsData } from '@/interfaces/reviews.interface';
import { parseISO, format } from 'date-fns';
import { hideImgOnError } from '@/helpers/helpers';
import { DEV_ABSOLUTE_URL } from '@/helpers/variables';
import styles from './BookReviewItem.module.scss';

interface IBookReviewItem {
  review: IReviewsData;
}

const BookReviewItem: FC<IBookReviewItem> = ({ review }) => {
  const { book_title, created_at, message, rating, votes, name, author_alias, book_alias } = review;

  // const bookFullAlias = `/author/${book.author.alias}/${book_id}`;
  const bookFullAlias = `/authors/${author_alias}/${book_alias}`;

  return (
    <div className={styles.bookReview}>
      <div className={styles.bookReview__wrap}>
        <div className={styles.bookReview__image}>
          <Link prefetch={false} className={styles.bookReview__imageLink} href={bookFullAlias}>
            <img width="54" height="54" src={`${DEV_ABSOLUTE_URL}/covers/${review.external_id}.jpg`} alt={book_title} onError={hideImgOnError} />
          </Link>
        </div>

        <div className={styles.bookReview__desc}>
          {!!review.created_at && created_at!.length > 0 && (
            <div className={styles.bookReview__addDate}>
              <time dateTime={created_at}>{format(parseISO(created_at!), 'dd.MM.yyyy HH:mm')}</time>
            </div>
          )}
          <Link prefetch={false} className={styles.bookReview__title} href={bookFullAlias}>
            {book_title}
          </Link>
          <div className={styles.bookReview__rating}>
            <BookCardRating rating={Math.ceil(rating)} voted={votes} />
          </div>
        </div>
      </div>

      <div className={styles.bookReview__txt}>{message}</div>
      <div className={styles.bookReview__author}>
        <b>Читатель:</b> {name}
      </div>
    </div>
  );
};

export default BookReviewItem;
